export function getMonthIndex(monthName) {
  const months = {
    'Январь': 1, 'Февраль': 2, 'Март': 3, 'Апрель': 4,
    'Май': 5, 'Июнь': 6, 'Июль': 7, 'Август': 8,
    'Сентябрь': 9, 'Октябрь': 10, 'Ноябрь': 11, 'Декабрь': 12
  };
  return months[monthName];
}

// Функция для поиска данных по месяцу и году
export function findMonthData(byDatesArray, monthIndex, year) {
  if (!byDatesArray) return null;
  
  const found = byDatesArray.find(item => 
    item.month === monthIndex && item.year === parseInt(year)
  );
  
  return found ? {
    ...found,
    projectCount: found.projectsCount,
    workspaceCount: found.workspaceCount,
    withX: found.withX
  } : null;
}


export const getMonthName = (monthIndex) => {
  const months = [
    "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
    "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
  ];
  return months[monthIndex];
};